<div class="padding-small bg-light-grey padding-left-large small">
  <div class="flex center">
    <span class="primary hover" (click)="onBack()">Third parties applications</span>
    <i class="fa-solid fa-angle-right padding-right-small padding-left-small grey"></i>
    Export {{ exportChannel?.label }} templates
  </div>
</div>

<div class="page-layout-small padding-large m-margin-none m-padding m-padding-top-largest">
  <div class="flex margin-bottom">
    <div class="flex-1 flex center">
      <h4>Search export {{ exportChannel?.label }} templates</h4>
    </div>
  </div>

  <div class="flex wrap gap">
    <div
      class="filter-chip"
      [ngClass]="!exportTemplateFilters.brands || !exportTemplateFilters.brands.length ? '' : 'selected'"
    >
      @if (exportTemplateFilters.brands && exportTemplateFilters.brands.length) {
        <div class="flex center hover" (click)="openBrandFilterModal()">
          <b class="margin-right-smallest">Brand:</b>

          @for (brand of exportTemplateFilters.brands; track brand; let last = $last) {
            {{ brand.name }}
            @if (!last) {
              ,
            }
          }
        </div>
        <mat-icon class="hover" (click)="cleanFilter('brands')">close</mat-icon>
      } @else {
        <div class="flex center hover" (click)="openBrandFilterModal()">
          Brand
          <mat-icon class="hover">edit</mat-icon>
        </div>
      }
    </div>

    <div
      class="filter-chip"
      [ngClass]="!exportTemplateFilters.categories || !exportTemplateFilters.categories.length ? '' : 'selected'"
    >
      @if (exportTemplateFilters.categories && exportTemplateFilters.categories.length) {
        <div class="flex center hover" (click)="openCategoryFilterModal()">
          <b class="margin-right-smallest">Category:</b>
          @for (category of exportTemplateFilters.categories; track category; let last = $last) {
            {{ category.name }}
            @if (!last) {
              ,
            }
          }
        </div>
        <mat-icon class="hover" (click)="cleanFilter('categories')">close</mat-icon>
      } @else {
        <div class="flex center hover" (click)="openCategoryFilterModal()">
          Category
          <mat-icon class="hover">edit</mat-icon>
        </div>
      }
    </div>

    <div
      class="filter-chip disabled"
      [ngClass]="!exportTemplateFilters.styleGroups || !exportTemplateFilters.styleGroups.length ? '' : 'selected'"
    >
      @if (exportTemplateFilters.styleGroups && exportTemplateFilters.styleGroups.length) {
        <div class="flex center hover" (click)="openStyleGroupFilterModal()">
          <b class="margin-right-smallest">Style Group:</b>
          @for (styleGroup of exportTemplateFilters.styleGroups; track styleGroup; let last = $last) {
            {{ styleGroup.name }}
            @if (!last) {
              ,
            }
          }
        </div>
        <mat-icon class="hover" (click)="cleanFilter('styleGroups')">close</mat-icon>
      } @else {
        <div class="flex center hover" (click)="openStyleGroupFilterModal()">
          Style Group
          <mat-icon class="hover">edit</mat-icon>
        </div>
      }
    </div>
  </div>

  @if (exportTemplates && exportTemplates.items && exportTemplates.items.length) {
    <div class="flex column end between margin-bottom margin-top-small">
      <button [routerLink]="['/company/third-parties-applications', exportChannel?.id, 'new']" class="flex center">
        <i class="fa fa-solid fa-plus margin-right-smallest"></i>
        Create Template
      </button>
    </div>

    <bt-paginator
      [pageNumber]="exportTemplates.currentPage"
      [pageSize]="exportTemplates.size"
      [totalNumber]="exportTemplates.totalCount"
      (clickPage)="pageEvent($event)"
    ></bt-paginator>

    <table class="margin-top-smallest">
      <tr>
        <th>Name</th>
        <th>Action</th>
      </tr>
      @for (item of exportTemplates.items; track item) {
        <tr>
          <td>
            <div class="flex column">
              @if (item.isDefault) {
                <div class="flex center">
                  <span class="margin-right-smallest bold">Default template</span>
                </div>
                <span class="grey small margin-top-smallest">
                  <i class="fa fa-solid fa-lock margin-right-smallest"></i>
                  This template is used as default for styles without a specific template.
                </span>
              } @else {
                <div class="flex center">
                  <span class="margin-right-smallest bold">Template {{ item.id }}</span>
                </div>

                <div class="flex wrap gap margin-top-small">
                  @if (item.brand?.name) {
                    <span class="radius bg-lightest-blue padding-right-smallest padding-left-smallest">
                      Brand: {{ item.brand.name }}
                    </span>
                  }
                  @if (item.collection?.name) {
                    <span class="radius bg-lightest-blue padding-right-smallest padding-left-smallest">
                      Collection: {{ item.collection.name }}
                    </span>
                  }
                  @if (item.category?.name) {
                    <span class="radius bg-lightest-blue padding-right-smallest padding-left-smallest">
                      Category: {{ item.category.name }}
                    </span>
                  }
                  @if (item.gender?.name) {
                    <span class="radius bg-lightest-blue padding-right-smallest padding-left-smallest">
                      Gender: {{ item.gender.name }}
                    </span>
                  }
                  @if (item.styleGroup?.name) {
                    <span class="radius bg-lightest-blue padding-right-smallest padding-left-smallest">
                      Style Group: {{ item.styleGroup.name }}
                    </span>
                  }
                </div>
              }
            </div>
          </td>

          <td>
            <div class="flex center">
              <a
                [routerLink]="['/company/third-parties-applications', exportChannel?.id, item.id]"
                class="hover primary flex center margin-right-small"
              >
                <mat-icon class="small margin-right-smallest">visibility</mat-icon>
                View
              </a>
              @if (!item.isDefault) {
                <span class="hover red flex center" (click)="removeExportTemplate(item)">
                  <i class="fa fa-xmark small margin-right-smallest"></i>
                  Remove
                </span>
              }
            </div>
          </td>
        </tr>
      }
    </table>

    <bt-paginator
      [pageNumber]="exportTemplates.currentPage"
      [pageSize]="exportTemplates.size"
      [totalNumber]="exportTemplates.totalCount"
      (clickPage)="pageEvent($event)"
    ></bt-paginator>
  }

  @if (exportTemplates.items.length == 0 && !loading) {
    <div class="flex center bg-light-grey padding-largest justify-center">
      <div class="flex column center gap">
        <i class="fa fa-search fa-2xl margin-bottom grey"></i>
        <span>No data found</span>
      </div>
    </div>
  }
</div>

@if (loading) {
  <bt-loader></bt-loader>
}
